// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__22UNZ","description":"PatientConsentPreview_description__MWgab"};